import React, { Component } from "react";
import styled from "styled-components";
import getVideoId from "get-video-id";
import YouTube from "react-youtube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import ReactDOM from "react-dom";
import { media } from "utils/Media";


		
class Portal extends Component {

  constructor() {
    super()
        //Use a ternary operator to make sure that the document object is defined
    this.portalRoot = typeof document !== `undefined` ? document.getElementById('portal') : null;
    // Use a ternary operator to make sure that the document object is defined
    this.el = typeof document !== `undefined` ? document.createElement('div') : null
  }

  componentDidMount = () => {    
    this.portalRoot.appendChild(this.el)
  }

  componentWillUnmount = () => {
    this.portalRoot.removeChild(this.el)
  }

  render() {
    const { children } = this.props



    // Check that this.el is not null before using ReactDOM.createPortal
    if (this.el) {
      return ReactDOM.createPortal(children, this.el)
    } else {
      return null
    }

  }
}		

const Placeholder = styled.div`
    position: relative;
    .duration {
    	position: absolute;
    	bottom: 0;
    	right: 0;
    	z-index: 2;
    	background: ${props => props.theme.colors.primary};
    	height: 20px;
		font-size: 0.875rem;/*14*/
		line-height: 20px;
		color: white;
		padding: 0 5px;
    }
`

const YouTubePop = styled.div`
	position: fixed;
	z-index: 100;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(50, 55, 65, .9);
	transform: translateZ(0);
`

const YouTubePlayer = styled.div`
    position: absolute;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 30px);
    overflow: visible;
    @media ${media.lg} {
		width: 1200px;
    }
`

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
    position: absolute;
    z-index: 102;
    color: #fff;
    width: 30px !important;
    height: 30px;
    right: .5rem;
    top: .5rem;
    cursor: pointer;
`

class YoutubeVideoOverlay extends Component {
    constructor(props) {
        super(props)

        this.state = {
            playing: false
        }
    }

    onReady = (e) => {
    	e.target.playVideo()
    }

    play = (e) => {
    	e.stopPropagation();
    	this.setState({
            playing: true
        })
    }

    close = (e) => {
    	e.stopPropagation();
    	this.setState({ playing: false });
    }

    render() {
        const videoID = getVideoId(this.props.oembed).id

        const opts = {
            playerVars: { // https://developers.google.com/youtube/player_parameters
                rel: 0,
                modestbranding: 1,
                showinfo: 0,
                playerVars: {
                    autoplay: 1
                }
            }
        };

        return(
            <div onClick={this.play} onKeyDown={this.play} role="button" tabIndex={0}>
                {this.props.placeholder !== null &&
                    <Placeholder ref={placeholder => this.placeholder = placeholder}>
                        {this.props.children}
                    </Placeholder>
                }
                
                {
                	this.state.playing
                	? <Portal>
                	      <YouTubePop onClick={this.close}>
	                		  <YouTubePlayer className="embed-responsive embed-responsive-16by9">
		                		<StyledFontAwesomeIcon icon={faTimes} onClick={this.close} />
			                    <YouTube
			                        videoId={videoID}
			                        opts={opts}
			                        onReady={this.onReady}
			                        className="embed-responsive-item"
			                    />
		                      </YouTubePlayer>
	                      </YouTubePop>
	                  </Portal>
	                : null
                }                
            </div>
        )
    }
}

export default YoutubeVideoOverlay